import '../App.css';
import React, {useState, useEffect} from 'react';
import { Link, useNavigate } from "react-router-dom";

function DisplayWordOptions() {

  const navigate = useNavigate();

  const searchCriteria = { 
    value: window.sessionStorage.getItem("query"),
    type: window.sessionStorage.getItem("searchType")
  }

  const searchResults = JSON.parse(window.sessionStorage.getItem("results"));
  const displayWord = searchCriteria.type === "yoruba" ? searchResults[0].yoruba_1 : searchResults[0].english_1;

  useEffect(() => {
    console.log(searchCriteria);

    if (searchCriteria.value && displayWord) {
      if (searchCriteria.value.toLowerCase() === displayWord.toLowerCase()){
        window.sessionStorage.setItem("displayWord", JSON.stringify(searchResults[0]));
        navigate("/word");
      }
    }
  });
  
  const updateDisplayWord = (word) => {
    window.sessionStorage.setItem("displayWord", JSON.stringify(word));
    // Send backend POST request!
    sendPostRequest(word['yoruba_1']);
    navigate("/word");
  }

  const sendPostRequest = async (word) => {
    try {
      const response = await fetch("https://yorubadictionary.yale.edu/api/updateMetaData", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          word: word
        }),
      });
  
      if (!response.ok) {
        throw new Error("Failed to fetch audio");
      }

      const res = await response;
      console.log(res);
    } catch (err) {
      console.error("Error sending choice to audio:", err);
    }
  }

  return (
    <div className="Home">
      <header className="App-header">
        <h3 style={{textAlign:"center"}}>The Yoruba Dictionary</h3>

        <p style={{textAlign:"center"}}>
          An exact translation for "{searchCriteria.value}" was not found, but here might be some close matches!
        </p>

        {/* Grid begins here*/}
        <div className="grid-container">
          {searchResults.map((word, index) => (
            <Link key={index} className="grid-item" onClick={() => {updateDisplayWord(word)}}>
              {searchCriteria.type === "yoruba" ? word.yoruba_1 : word.english_1}
              <br />
            </Link>
          ))}
        </div>

        <p style={{textAlign:"center"}}>
          Didn't find it? <Link onClick={() => sendPostRequest("")} to="/" className="App-link">Search For Another Word</Link>
        </p>

      </header>
    </div>
  );
}
  
export default DisplayWordOptions;